import { Button, Col, Flex, Form, Image, Input, InputNumber, Modal, Row, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import iconDecrease from '../../../assets/images/schedules/icon-amount-decrease.svg';
import iconIncrease from '../../../assets/images/schedules/icon-amount-increase.svg';
import iconDelete from '../../../assets/images/schedules/icon-delete-price.svg';
import PriceInputSegment from '../../../components/PriceInputSegment';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { ListScheduleSelector, setListFare, setListLock } from '../../../redux/slice/schdules/scheduleSlice';
import '../../schedules/Schedules.scss';

const PriceModal: React.FC<any> = ({
  okText,
  cancelText,
  modalOpen,
  onCancel,
  onOk,
  loading,
  isDetail,
  priceRangeActive,
  route,
  routeId,
  className,
  listTypeBus,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(modalOpen);
  const [isErrorAmount, setIsErrorAmount] = useState(false);
  const [isMessageErrorAmount, setIsMessageAmount] = useState('');
  const { listSegment, fares, locks, dataSchedule } = useAppSelector(ListScheduleSelector);
  const [formPrice] = Form.useForm();
  const dispatch = useAppDispatch();
  const modalHandleOk = () => {
    onOk();
  };
  const findColor = (keyIndex: any) => {
    const item =
      listTypeBus?.groupSeat?.length && listTypeBus?.groupSeat?.find((_: any, index: any) => +index === +keyIndex);
    return item ? item?.group_color : null;
  };
  const modalHandleCancel = () => {
    formPrice.resetFields();
    onCancel();
  };
  const handleDecreaseAmount = (index: number) => {
    const currentAmount = formPrice.getFieldValue(['price_common', index, 'amount']) || 0;
    if (currentAmount > 0) {
      formPrice.setFieldsValue({
        price_common: formPrice
          .getFieldValue('price_common')
          .map((item: any, idx: number) => (idx === index ? { ...item, amount: currentAmount - 1 } : item)),
      });
    }
    const priceCommon = formPrice.getFieldValue('price_common');
    const totalAmount = priceCommon.reduce((sum: any, item: any) => sum + (item?.amount || 0), 0);
    if (totalAmount > listSegment?.seat_map?.seat_number) {
      setIsErrorAmount(true);
    } else {
      setIsErrorAmount(false);
    }
  };
  const handleIncreaseAmount = (index: number) => {
    const currentAmount = formPrice.getFieldValue(['price_common', index, 'amount']) || 0;
    formPrice.setFieldsValue({
      price_common: formPrice
        .getFieldValue('price_common')
        .map((item: any, idx: number) => (idx === index ? { ...item, amount: currentAmount + 1 } : item)),
    });
    const priceCommon = formPrice.getFieldValue('price_common');
    const totalAmount = priceCommon.reduce((sum: any, item: any) => sum + (item?.amount || 0), 0);
    if (totalAmount > listSegment?.seat_map?.seat_number) {
      setIsErrorAmount(true);
    } else {
      setIsErrorAmount(false);
    }
  };

  const onFinish = (values: any) => {
    const price_range = values.price_json.map((priceItem: any) => ({
      name: priceItem?.name,
      price: priceItem?.price,
    }));
    const price_common = values.price_common.map((priceItem: any) => ({
      name: priceItem?.name,
      price: priceItem?.price,
      amount: priceItem?.amount,
    }));
    const newFare = {
      route: routeId,
      price_range,
      price_common: price_common ? price_common : [],
    };
    const newLocks = {
      id: routeId,
      status: {
        company: false,
        agent: false,
        api: false,
      },
    };
    let updatedFares = Array.isArray(fares) ? [...fares] : [];
    let updatedLocks = Array.isArray(locks) ? [...locks] : [];
    const existingRouteIndex = updatedFares?.findIndex((fare: any) => fare?.route === routeId);

    if (existingRouteIndex !== -1) {
      updatedFares[existingRouteIndex] = newFare;
    } else {
      updatedFares.push(newFare);
      updatedLocks.push(newLocks);
    }
    dispatch(setListFare(updatedFares));
    dispatch(setListLock(updatedLocks));
    modalHandleCancel();
  };

  const handleDeletePrice = () => {
    let updatedFares = Array.isArray(fares) ? [...fares] : [];
    updatedFares = updatedFares?.filter((item) => {
      return item?.route !== routeId;
    });
    dispatch(setListFare(updatedFares));
    modalHandleCancel();
  };

  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);
  useEffect(() => {
    if (isDetail && priceRangeActive[0]?.route) {
      formPrice.setFieldsValue({
        price_json: priceRangeActive[0]?.price_range,
        price_common: priceRangeActive[0]?.price_common,
      });
      if (!priceRangeActive[0]?.price_common?.length) {
        const currentPriceCommon = formPrice.getFieldValue('price_common') || [];
        listTypeBus?.seat_map?.group_seat?.length > 0 &&
          listTypeBus?.seat_map?.group_seat?.map((item: any, index: number) => {
            return (currentPriceCommon[index] = {
              name: item.name,
              price: 0,
              amount: item?.selected_seat?.length,
            });
          });
        formPrice.setFieldsValue({
          price_common: currentPriceCommon,
        });
      }
    } else {
      if (listTypeBus?.seat_map?.group_seat?.length) {
        const currentValues = formPrice.getFieldValue('price_json') || [];
        listTypeBus?.seat_map?.group_seat?.length > 0 &&
          listTypeBus?.seat_map?.group_seat?.map((item: any, index: number) => {
            return (currentValues[index] = {
              name: item.name,
              price: 0,
            });
          });
        formPrice.setFieldsValue({
          price_json: currentValues,
        });
        const currentPriceCommon = formPrice.getFieldValue('price_common') || [];
        listTypeBus?.seat_map?.group_seat?.length > 0 &&
          listTypeBus?.seat_map?.group_seat?.map((item: any, index: number) => {
            return (currentPriceCommon[index] = {
              name: item.name,
              price: 0,
              amount: item?.selected_seat?.length,
            });
          });
        formPrice.setFieldsValue({
          price_common: currentPriceCommon,
        });
      }
    }
  }, [listTypeBus, formPrice, modalOpen, isDetail, priceRangeActive]);

  return (
    <Modal
      open={isModalOpen}
      onOk={modalHandleOk}
      onCancel={modalHandleCancel}
      cancelText={cancelText}
      okText={okText}
      centered
      width={560}
      maskClosable={false}
      footer={
        <>
          <Row className="d-flex justify-between mt-1">
            <Button
              loading={loading}
              key="delete"
              className="btn-delete price text-white"
              onClick={() => handleDeletePrice()}
            >
              <Image src={iconDelete} preview={false} />
              Xóa giá vé
            </Button>
            <Flex>
              <Button loading={loading} key="cancel" className="btn-cancel me-3" onClick={() => modalHandleCancel()}>
                Đóng
              </Button>
              <Button
                key="submit"
                type="primary"
                loading={loading}
                className="w-160 h-btn-48 btn-success mr-0"
                htmlType="submit"
                onClick={formPrice.submit}
              >
                Lưu
              </Button>
            </Flex>
          </Row>
        </>
      }
      className="modal-segment-block booking-schedule-modal "
      styles={{ body: { maxHeight: '650px', overflowY: 'auto', overflowX: 'hidden', paddingBottom: '30px' } }}
    >
      <Typography
        className="fs-18 fw-600"
        style={{ color: '#444444', paddingBottom: '12px', borderBottom: '1px solid #EEEEEE' }}
      >
        Cấu hình giá vé
      </Typography>
      <div className={`block-bg-color-200 mt-3`}>
        <div className={`block-price-route ${className}`}>
          <p className={`color-700 fs-16 fw-600 ${className}`}>{route}</p>
        </div>
      </div>
      <Form
        name="segment-price-form"
        layout="vertical"
        form={formPrice}
        onFinish={onFinish}
        className="mt-3 segment-price-form"
        colon={false}
        validateTrigger="onSubmit"
        initialValues={{
          price_json: [],
          price_common: null,
        }}
      >
        <div className="price-modal-block mt-4">
          <div className="bg-title">
            <span>Giá có sơ đồ</span>
          </div>
          <Form.List name="price_json">
            {(fields) => (
              <div className="form-price-block">
                {fields.map(({ key, name }) => (
                  <Row key={key}>
                    <Col xs={24} md={8}>
                      <span className={`first-color-block json ${findColor(key)} `}></span>
                      <Form.Item
                        name={[name, 'name']}
                        className="form-item-name required group-input color"
                        validateTrigger={['onChange', 'onBlur']}
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={16} className="price-input">
                      <PriceInputSegment name={name} form={formPrice} isCommon={false} />
                    </Col>
                  </Row>
                ))}
              </div>
            )}
          </Form.List>
        </div>
        <div className="price-modal-block mt-4">
          <div className="bg-title">
            <span>Giá không sơ đồ</span>
          </div>
          <Row className="price-ticket-block common">
            <Col xs={24} md={24}>
              <Form.List name="price_common">
                {(fields) => (
                  <div className="form-price-block">
                    {fields.map(({ key, name }) => (
                      <Row key={key} className="items-center">
                        <Col xs={24} md={8} className="price-input">
                          <span className={`first-color-block json ${findColor(key)} `}></span>
                          <Form.Item
                            name={[name, 'name']}
                            className="form-item-name required group-input color"
                            validateTrigger={['onChange', 'onBlur']}
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                        <Col xs={24} md={7} className="price-input">
                          <PriceInputSegment name={name} form={formPrice} isCommon={true} />
                        </Col>
                        <Col xs={24} md={9}>
                          <div className="d-flex amount-seat-block">
                            <div
                              className="amount-item-box increase cursor-pointer"
                              onClick={() => handleDecreaseAmount(name)}
                            >
                              <img src={iconDecrease} alt="" />
                            </div>
                            <Form.Item
                              name={[name, 'amount']}
                              className="form-item-name required "
                              validateTrigger={['onChange', 'onBlur']}
                              rules={[
                                {
                                  validator: async (_) => {
                                    const priceCommon = formPrice.getFieldValue('price_common') || [];
                                    const totalAmount = priceCommon.reduce(
                                      (sum: any, item: any) => sum + (item?.amount || 0),
                                      0,
                                    );
                                    if (!dataSchedule?.is_diagram_company || !dataSchedule?.is_diagram_openapi) {
                                      if (!totalAmount) {
                                        setIsErrorAmount(true);
                                        setIsMessageAmount('Vui lòng nhập số ghế');
                                        return Promise.reject(new Error(''));
                                      } else {
                                        setIsErrorAmount(false);
                                        setIsMessageAmount('');
                                      }
                                    } else {
                                      if (totalAmount > listSegment?.seat_map?.seat_number) {
                                        setIsErrorAmount(true);
                                        return Promise.reject(new Error(''));
                                      } else {
                                        setIsErrorAmount(false);
                                        setIsMessageAmount('');
                                      }
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <InputNumber
                                suffix="ghế"
                                controls={false}
                                maxLength={3}
                                onWheel={(event) => event.currentTarget.blur()}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </Form.Item>
                            <div
                              className="amount-item-box decrease cursor-pointer"
                              onClick={() => handleIncreaseAmount(name)}
                            >
                              <img src={iconIncrease} alt="" />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </div>
                )}
              </Form.List>
              {isErrorAmount && isMessageErrorAmount ? (
                <p className="fs-14 text-danger fw-500">{isMessageErrorAmount}</p>
              ) : isErrorAmount ? (
                <p className="fs-14 text-danger fw-500">
                  Tổng số ghế không vượt quá {listSegment?.seat_map?.seat_number ?? 0} ghế
                </p>
              ) : (
                ''
              )}
            </Col>
          </Row>
        </div>
      </Form>
    </Modal>
  );
};

export default PriceModal;
